import { Component } from '@angular/core';

@Component({
    selector: 'db-product-list-section-placeholder',
    templateUrl: './product-list-section-placeholder.component.html',
    styleUrl: './product-list-section-placeholder.component.scss',
    standalone: false
})
export class ProductListSectionPlaceholderComponent {

}
